import Layout from "@/layout";
export default {
  path: "ReportForm",
  component: () => import('@/views/AppMain/index'),
  name: "ReportForm",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "财务管理",
    keepAlive: false,
    icon: "1023",
    activeIcon: "1022"
    // activeMenu: '/HeadOfficeManagement/BasicDataManage/BasicData'
  },
  children: [
    {
      hidden: false,
      path: "BusinessData",
      component: () => import("@/views/HeadOfficeManagement/ReportForm/BusinessData"),
      name: "BusinessData",
      meta: {
        title: "营业数据",
        keepAlive: true,
      },
    },
    {
        hidden: false,
        path: "CommodityStatistics",
        component: () => import("@/views/HeadOfficeManagement/ReportForm/CommodityStatistics"),
        name: "CommodityStatistics",
        meta: {
          title: "商品统计",
          keepAlive: true,
        },
      },
      {
        hidden: true,
        path: "StoreStatistics",
        component: () => import("@/views/HeadOfficeManagement/ReportForm/StoreStatistics"),
        name: "StoreStatistics",
        meta: {
          title: "门店统计",
          keepAlive: true,
          activeMenu: '/HeadOfficeManagement/ReportForm/BusinessData'
        },
      },
      {
        hidden: true,
        path: "ActiveReport",
        component: () => import("@/views/AppMain"),
        name: "ActiveReport",
        alwaysShow: true,
        meta: {
          title: "活动报表",
          keepAlive: false,
        },
        children: [
          {
            hidden: false,
            path: "SpecialOffer",
            component: () => import("@/views/HeadOfficeManagement/ReportForm/FullReductionActivity"),
            name: "SpecialOffer",
            meta: {
              title: "限时特价",
              keepAlive: true,
            },
          },{
            hidden: false,
            path: "FullReductionActivity",
            component: () => import("@/views/HeadOfficeManagement/ReportForm/FullReductionActivity"),
            name: "FullReductionActivity",
            meta: {
              title: "满减活动",
              keepAlive: true,
            },
          },{
            hidden: false,
            path: "Presale",
            component: () => import("@/views/HeadOfficeManagement/ReportForm/FullReductionActivity"),
            name: "Presale",
            meta: {
              title: "预售活动",
              keepAlive: true,
            },
          },
        ]
      },
      {
        hidden: false,
        path: "TradingProfit",
        component: () => import("@/views/HeadOfficeManagement/ReportForm/TradingProfit"),
        name: "TradingProfit",
        meta: {
          title: "销售毛利",
          keepAlive: true,
        },
      },
      {
        hidden: true,
        path: "TradingProfitDetail",
        component: () => import("@/views/HeadOfficeManagement/ReportForm/TradingProfitDetail"),
        name: "TradingProfitDetail",
        meta: {
          title: "详情",
          keepAlive: false,
          activeMenu: '/HeadOfficeManagement/ReportForm/TradingProfit'
        },
      },
      {
        hidden: true,
        path: "ShiftHandover",
        component: () => import("@/views/HeadOfficeManagement/ReportForm/ShiftHandover"),
        name: "ShiftHandover",
        meta: {
          title: "交接班",
          keepAlive: true,
        },
      },
  ]
};
